import { useCallback, useEffect, useMemo } from 'react'

import { CursorState } from '@editor/config/constants/cursor'
import { EditorConfig } from '@editor/interfaces/editor'
import { BlueprintEditorTools } from '@editor/pages/projects/blueprint-editor/definitions'
import { useAppDispatch, useAppSelector } from '@editor/store/app'
import { setCursor } from '@editor/store/tool'

import { setBatchGenerate } from '../../TextAnnotation/store'

const useEditor = (): EditorConfig => {
  // Store
  const dispatch = useAppDispatch()
  const selectedTool = useAppSelector((state) => state.blueprint.editor.selectedTool)
  const prevSelectedTool = useAppSelector((state) => state.blueprint.editor.prevSelectedTool)
  const canBatchGenerate = useAppSelector((state) => state.blueprint.tools.textAnnotation.canBatchGenerate)

  // Derived state
  const isToolSelected = useMemo(() => selectedTool === BlueprintEditorTools.TextAnnotation, [selectedTool])
  const isPreviousTool = useCallback((tool: BlueprintEditorTools) => prevSelectedTool === tool, [prevSelectedTool])

  /**
   * When user changes tools (in or out of TextAnnotation tool), update cursor.
   */
  useEffect(() => {
    if (isToolSelected) {
      dispatch(setCursor(CursorState.CROSSHAIR))
    } else if (isPreviousTool(BlueprintEditorTools.TextAnnotation) && selectedTool !== BlueprintEditorTools.Focus) {
      dispatch(setCursor(CursorState.DEFAULT))
    }
  }, [isToolSelected, selectedTool, isPreviousTool, dispatch])

  return {
    buttons: {
      submit: {
        label: '自動一括作成',
        isShown: () => isToolSelected,
        isDisabled: () => !canBatchGenerate,
        onClick: () => {
          dispatch(setBatchGenerate(true))
        },
      },
    },
  }
}

export default useEditor
